<template>
    <div class="field">

        <autocomplete v-model="article.publication_name" :matchingItems="matchingItems" />

    </div>
</template>

<script>
    import Autocomplete from '@/components/fields/Autocomplete.vue'

    export default {
        components: {
          Autocomplete,
        },
        props: [ 'article', 'tags'],
        data () {
            return {
                publications: [],
            }
        },
        methods: {
            matchingItems (text) {
              if(!this.publications){
                this.loadData();
              }else{
                var items = []
                for(var i=0;i<this.publications.length;i++){
                  if(this.publications[i].name.toLowerCase().indexOf(text.toLowerCase()) !== -1){
                    items.push(this.publications[i])
                  }
                }
                return items;
              }
            }
        },
        mounted () {
          this.$http.get('/portfolio/publications/').then((data) => {
            this.publications = data.data
          });
        }
    }
</script>
